import { AppStore } from "../../store/modules/app";
import { PersonStore } from "../../store/modules/person";
import { ConfigStore } from "../../store/modules/config";
import { DiTokens } from "../../services/diTokens";
import IAlertService from "../../services/alert/IAlertService";
import { Vue, Watch } from "vue-property-decorator";
import { getModule } from "vuex-module-decorators";
import ISubscriptionService from "../../services/subscription/ISubscriptionService";
import {UserSubscriptionData} from '../../data/userSubscriptionData';
import { container } from "@/inversify.config";

export class SubscriptionListVue extends Vue {

  // stores:

  /** Стор приложения */
  get appStore(): AppStore {
    return getModule(AppStore, this.$store);
  }

  /** Стор приложения */
  get configStore(): ConfigStore {
    return getModule(ConfigStore, this.$store);
  }

  /** Стор приложения */
  get personStore(): PersonStore {
    return getModule(PersonStore, this.$store);
  }

  // services:

  get subService(): ISubscriptionService {
    return container.get<ISubscriptionService>(DiTokens.SubscriptionService);
  }

  get alertService(): IAlertService {
    return container.get<IAlertService>(DiTokens.AlertService);
  }

  // watchers:

  @Watch('editDialog', { immediate: true })
  dialogToggle(val: boolean) {
    if (!val) {
      this.selectedItem = {};
      this.isNew = false;
    }
  }

  // data:

  editDialog: boolean = false;

  selectedItem: any = {};

  isNew: boolean = false;

  // computed:

  get subscriptions(): Array<UserSubscriptionData> {
    return this.personStore.subscriptions;
  }

  get loading(): boolean {
    return this.personStore.loading;
  }

  get isVip(): boolean {
    return this.personStore.personInfo?.Data?.Vip;
  }

  // methods:

  editItem(item: UserSubscriptionData): void {
    this.selectedItem = item;
    this.isNew = false;
    this.editDialog = true;
  }

  addItem(): void {
    this.isNew = true;
    this.editDialog = true;
  }

  closeDialog(): void {
    this.editDialog = false;
  }

  async deleteSub(item: UserSubscriptionData): Promise<void> {
    this.appStore.setLoading(true);
    await this.personStore.deleteSubscription(item.Id);
    this.appStore.setLoading(false);
  }

}
